module.exports = __webpack_public_path__ + "static/media/photo1.854d9f38.jpg";